import UrlPattern from "url-pattern";
import { ConfigurationErrorBadModule } from "@errors/ConfigurationError";

export function getBaseUrl(link, params) {
  if (!link || !link.url) return "";
  const url = link.url.split("(")[0];
  return params ? new UrlPattern(url).stringify(params) : url;
}

export function listRoutes(link, { domain, group }, parentLinks = []) {
  return listLinks(link).reduce(
    (acc, l) => [
      ...acc,
      ...listRoutes(l, { domain, group }, [...parentLinks, link]),
    ],
    [buildLinkRoute(domain, group, parentLinks, link)]
  );
}

function buildLinkRoute(domain, group, parentLinks, link) {
  return {
    key: link.id,
    type: "link",
    path: getBaseUrl(link),
    props: { domain, group, links: [...parentLinks, link] },
  };
}

export function listLinks(link) {
  if (!link) return [];
  return link.links || [];
}

export function containsLink(link, linkId) {
  if (link.id === linkId) return true;
  return link.links.some((l) => containsLink(l, linkId));
}

export function validateLink(unreferencedLink) {
  validateModuleIdUniqueness(unreferencedLink);
}

function validateModuleIdUniqueness(link) {
  link.modules.reduce((usedIds, module) => {
    if (usedIds.includes(module.id))
      throw ConfigurationErrorBadModule({
        error: "DuplicateModuleId",
        moduleId: module.id,
      });
    return [...usedIds, module.id];
  }, []);
}
